import React, { useState, useEffect, useContext, useCallback } from "react";
import { MindmapEditor } from "./MindmapEditor";
import { MindmapDashboard } from "./MindmapDashboard";
import { IMindmap, getMindmaps, createMindmap, IMindmapData } from "../../api/mindmap";
import { DashboardContext } from "../dashboardPage/DashboardContext";
import { AppContext } from "../../appContext";
import "./Mindmap.css";

export const Mindmap = () => {
    const [selectedItem, setSelectedItem] = useState<IMindmap | null>(null);
    const [items, setItems] = useState<IMindmap[]>([]);
    const [loading, setLoading] = useState(true);
    const [initialLoadDone, setInitialLoadDone] = useState(false);
    const { selectedClientId } = useContext(DashboardContext);
    const { translate } = useContext(AppContext);

    const loadMindmaps = useCallback(async () => {
        if (!selectedClientId) {
            setItems([]);
            setLoading(false);
            setInitialLoadDone(true);
            return;
        }
        setLoading(true);
        const data = await getMindmaps(selectedClientId);
        setItems(data);
        setLoading(false);
        setInitialLoadDone(true);
    }, [selectedClientId]);

    useEffect(() => {
        setInitialLoadDone(false);
        loadMindmaps();
    }, [selectedClientId, loadMindmaps]);

    const handleAddMindmap = async (): Promise<IMindmap | null> => {
        if (!selectedClientId) return null;
        
        const newName = translate('mindmap_new_board') || 'New Board';
        const emptyData: IMindmapData = { objects: [] };
        
        const created = await createMindmap(selectedClientId, newName, emptyData);
        if (created) {
            setItems(prev => [created, ...prev]);
            return created;
        }
        return null;
    };

    const handleSelect = (item: IMindmap) => {
        setSelectedItem(item);
    };

    const handleUpdateItem = (updatedItem: IMindmap) => {
        setItems(prev => prev.map(item => 
            item.id === updatedItem.id ? updatedItem : item
        ));
    };

    const handleDeleteItem = (deletedId: string) => {
        setItems(prev => prev.filter(item => item.id !== deletedId));
    };

    return <div className="Mindmap">
        {!selectedItem && (
            <MindmapDashboard 
                items={items}
                loading={loading && !initialLoadDone}
                onSelect={handleSelect}
                onAddMindmap={handleAddMindmap}
                onDelete={handleDeleteItem}
            />
        )}
        {selectedItem && (
            <MindmapEditor 
                mindmapId={selectedItem.id} 
                initialName={selectedItem.name}
                onClose={() => setSelectedItem(null)}
                onUpdate={handleUpdateItem}
                onDelete={handleDeleteItem}
            />
        )}
    </div>
}
